import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconComponentVariants({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g fill={fill}>
                <path fill-rule="evenodd" d="M3.5 2.5a1 1 0 0 0 0 2h5a1 1 0 0 0 0-2h-5zm-2 1a2 2 0 0 1 2-2h5a2 2 0 1 1 0 4h-5a2 2 0 0 1-2-2z"/>
                <path d="M8.5 6.5h-5a2 2 0 1 0 0 4h5a2 2 0 1 0 0-4z"/>
            </g>
        </svg>
    );
}

export default IconComponentVariants;
